import React from 'react';
import classes from './Dialogue.module.css';
import Button from 'components/UI/Button/Button';

const Dialogue = (props) => {
  const wrapperClasses = [classes.DialogueWrapper];
  if (props.postForm) wrapperClasses.push(classes.PostForm);
  if (props.className) wrapperClasses.push(classes[props.className]);
  if (props.whiteBackground) wrapperClasses.push(classes.WhiteBackground);
  const messageLines = (props.message || '').split('<br />');
  return (
    <div className={wrapperClasses.join(' ')}>
      <div className={classes.DialogueBackground} />
      <div className={classes.DialogueContainer}>
        <div className={classes.DialogueSubject}>{props.subject}</div>
        <div className={classes.DialogueMessage}>
          {messageLines.map((line, i) => (
            <p key={i}>{line}</p>
          ))}
        </div>
        <div className={classes.DialogueControls}>
          {props.cancelText ? (
            <Button clicked={props.cancelled} btnType="DialogueCancel">
              {props.cancelText}
            </Button>
          ) : null}
          <Button clicked={props.confirm} btnType={props.dialogueType ? props.dialogueType : 'DialogueConfirmation'}>
            {props.confirmationText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Dialogue;
